<template>
  <div class="d-flex justify-center align-center">
    <div
      class="avatar-container"
      v-for="user in users"
      :key="user.userId"
      :style="`border-bottom: 3px solid ${user.color};`"
    >
      <div :style="`background-color: ${user.color};`">
        <Avatar
          :user-id="user.userId"
          :size="24"
          :show-tooltip="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from '@/shared/components/avatar/Avatar';

export default {
  name: 'ConnectedUsers',
  components: { Avatar },
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style scoped>
.avatar-container {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 2px;
  padding-bottom: 2px;
}
.avatar-container div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  padding: 2px;
  border-radius: 30px;
}
</style>
